import React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import ShadowBox from 'components/ShadowBox'
import Icon from 'components/Icon'
import PaymentMethods from 'components/PaymentMethods'
import ProgressSpinner from 'components/ProgressSpinner'
import { Form } from 'components/Form'
import formatCurrency from 'utils/formatCurrency'
import prefix from 'utils/prefix'
import './styles.sass'

let FeeBreakdown = ({ step }) => (
  <ShadowBox className="breakdown-box" level={2}>
    <div className="breakdown-header">
      {step.breakdownTitle}
    </div>
    <div className="order-lines">
      {step.orderLinesDisplay.map((orderLine) =>
        <OrderLine
          name={orderLine.product}
          calculating={orderLine.isDiscount && step.calculatingDiscount}
          price={orderLine.price}
          wrapPrice={orderLine.isDiscount}
          boldPrice={orderLine.bold}
          dashed={orderLine.dashed}
          key={orderLine.product}
        />
      )}
      <OrderLine name="Total" price={step.orderTotal} total boldPrice />
      <OrderLine name="Amount Due Now" price={step.amountDueNow} boldName boldPrice />
    </div>
    <div className="coupon-container">
      {step.couponsUsed.length > 0 &&
        <div className="coupons-used">
          {step.couponsUsed.map((c) =>
            <span key={c} className="coupon tag">{c}</span>
          )}
        </div>
      }

      {step.showingCouponField
        ? (
          <Form onSubmit={() => step.applyCoupon()}>
            <p className="control has-addons">
              <input
                type="text"
                className="input coupon-field"
                placeholder="Enter coupon code"
                value={step.couponCode}
                disabled={step.applyCoupon.pending}
                onChange={e => step.setCouponCode(e.target.value)}
              />
              <button
                type="submit"
                className={cx('button is-info', step.applyCoupon.pending && 'is-loading')}
                disabled={step.applyCoupon.pending || step.calculatePrice.pending || step.submitJob.pending || step.saveCard.pending}
              >
                Apply
              </button>
            </p>
          </Form>
        )
        : (
          <button className="coupon-button" onClick={() => step.toggleCouponField()} disabled={step.submitJob.pending}>
            {step.couponsUsed.length === 0 ? 'I have a coupon!' : 'I have another coupon!'}
          </button>
        )
      }
    </div>
    <a
      className="button pay-button"
      onClick={() => step.pay()}
      disabled={step.calculatePrice.pending || step.submitJob.pending || step.saveCard.pending}
    >
      <span className="icon">
        <Icon material name="credit card" />&nbsp;
      </span>
      <span>
        Secure Checkout
      </span>
    </a>
  </ShadowBox>
)

FeeBreakdown = observer(FeeBreakdown)

const orderLineModifiers = prefix('order-line--')

let OrderLine = ({ calculating, name, price, wrapPrice, boldName, total, boldPrice, dashed }) => (
  <div className={cx('order-line', orderLineModifiers({ total, boldPrice, boldName, dashed }))}>
    <div className="line-name">{name}</div>
    <div className="line-price">
      {calculating
        ? <ProgressSpinner blue />
        : typeof price === 'string'
          ? price
          : wrapPrice
            ? `(${formatCurrency(price)})`
            : formatCurrency(price)
      }
    </div>
  </div>
)

OrderLine = observer(OrderLine)

let PaymentMethodPicker = ({ step }) => {
  const { billingStore } = step.wizard.rootStore
  return (
    <ShadowBox className="breakdown-box" level={2}>
      <div className="breakdown-header flex">
        <div className="breakdown-header__filler">
          <a className="button is-icon-only" onClick={(e) => e.preventDefault() || step.showFeeBreakdown()}>
            <Icon material name="arrow back" />
          </a>
        </div>
        <div className="breakdown-header__text">
          Select Payment Method
        </div>
        <div className="breakdown-header__filler"></div>
      </div>
      <PaymentMethods
        loading={step.fetchPaymentMethods.pending}
        cards={billingStore.cards}
        busy={billingStore.busy || step.selectPaymentMethod.pending}
        onAddClick={() => billingStore.showAddCardCheckout()}
        onDeleteCardClick={card => billingStore.deletePaymentMethod(card)}
        onCardClick={card => step.selectPaymentMethod(card)}
      />
    </ShadowBox>
  )
}

PaymentMethodPicker = observer(PaymentMethodPicker)

export { PaymentMethodPicker, FeeBreakdown }



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/FeeBreakdown/Boxes/index.jsx